<script setup lang="ts">
defineProps({
  craftable: {
    type: Object as PropType<CraftItem>,
    required: true,
  },
  success: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["close"]);
</script>

<template>
  <div class="flex flex-col items-center gap-6">
    <div class="my-6">
      <NuxtIcon
        v-if="success"
        name="mdi:check-circle-outline"
        class="w-24 h-24 text-success-300" />
      <NuxtIcon
        v-else
        name="mdi:cancel-circle-outline"
        class="w-24 h-24 text-error-300" />
    </div>

    <div class="flex flex-col justify-center items-center gap-2 -mt-6">
      <template v-if="success">
        <h3 class="text-xl font-bold text-neutral-200">
          {{ $t("main.modalCraftResult.craftingSuccessful") }}
        </h3>
        <p class="text-neutral-300 max-w-xs text-center">
          {{
            $t("main.modalCraftResult.itemWillAppearInYourCollectionShortly")
          }}
        </p>
      </template>
      <template v-else>
        <h3 class="text-xl font-bold text-error-300">
          {{ $t("main.modalCraftResult.craftingFailed") }}
        </h3>
        <p class="text-neutral-300 max-w-xs text-center">
          {{
            $t(
              "main.modalCraftResult.somethingWentWrongPleaseTryAgainInAFewMinutes"
            )
          }}
        </p>
      </template>
    </div>

    <NuxtLinkLocale v-if="success" :to="`/collection/${craftable.merchantId}`">
      <BaseButtonSubmit
        @click="emit('close')"
        :text="$t('main.modalCraftResult.goToCollection')"
        :contextual-styles="true" />
    </NuxtLinkLocale>
    <BaseButtonSubmit
      v-else
      @click="emit('close')"
      :text="$t('main.modalCraftResult.close')"
      :contextual-styles="true" />
  </div>
</template>
